'use strict';
import $ from 'jquery';

/**
 * Ellipsis truncate
 * @param {object} el html element
 * @param {integer} limit character count
 * @param {string} after string to show after truncate (usually '...')
 */
export const truncate = (el, limit, after) => {
	if (!el || !limit || el.hasClass('ellipsed')) return;

	el = $(el);
	const fullContent = el.html();
	let content = el.text().substring(0, limit);

	if (content.length > 0) {
		if (el.text().length > limit) {
			content = after ? content + after : content;
			el.html('<div class="js-ellipsis-text-content">' + content + '</div>');
			el.append('<div class="js-ellipsis-content hidden">' + fullContent + '</div>');
			el.append('<button class="js-ellipsis-read-more ellipsis-read-more a-link">Lue lisää</button>');

			el.find('.js-ellipsis-read-more').on('click', function (e) {
				el.find('.js-ellipsis-text-content').remove();
				el.find('.js-ellipsis-content.hidden').removeClass('hidden');
				$(this).remove();
			});
			el.addClass('ellipsed');
		}
	}
}
